import { render, staticRenderFns } from "./CommonFormWithQuickMaterialCreator.vue?vue&type=template&id=472ca80e&lang=pug&"
import script from "./CommonFormWithQuickMaterialCreator.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithQuickMaterialCreator.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithQuickMaterialCreator.vue?vue&type=style&index=0&id=472ca80e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports